import { createGlobalStyle } from "styled-components";

// global
const GlobalLayoutStyles = createGlobalStyle`
    body {
        font-family: "Nunito Sans", sans-serif;
        font-weight: 400;
        font-size: 14px;
    }
    
    .st-text-primary {
        color: #4d4d4d;
        &:hover {
            color: #4d4d4d;
        }
    }
    .st-text-secondary {
        color: #808080;
        &:hover {
            color: #808080;
        }
    }

    .quantity-selector {
        input {
            height: 53px;
            width: 60px;
            padding: 10px;
            text-align: center;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type=number] {
            -moz-appearance: textfield;
        }

        .btns {
            height: 53px;
            width: 29px;
            padding: 0 0 0 5px;
            border-radius: 0.25rem;
            font-size: 13px;

            >span {
                height: calc(50% - 2px);
                background: #000;
                border-radius: .25rem;
                color: #fff;
                transition: .3s;
                cursor: pointer;
                user-select: none;
                &:hover {
                    background: #333;
                }
                &.plus {
                    margin-bottom: 4px;
                }
                &.minus {
                    margin-top: 4px;
                }
            }
        }
    }
`;

export { GlobalLayoutStyles };
